<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 2.5C15.1522 2.5 17.6957 3.55357 19.5711 5.42893C21.4464 7.3043 22.5 9.84784 22.5 12.5C22.5 18.0228 18.0228 22.5 12.5 22.5C6.97715 22.5 2.5 18.0228 2.5 12.5C2.5 6.97715 6.97715 2.5 12.5 2.5ZM12.5005 4.1668C7.89815 4.1668 4.16719 7.89776 4.16719 12.5001C4.16719 17.1025 7.89815 20.8335 12.5005 20.8335C17.1029 20.8335 20.8339 17.1025 20.8339 12.5001C20.8339 7.89776 17.1029 4.1668 12.5005 4.1668ZM19.4 12.5C19.4 8.68924 16.3108 5.6 12.5 5.6C8.68924 5.6 5.6 8.68924 5.6 12.5C5.6 16.3108 8.68924 19.4 12.5 19.4C16.3108 19.4 19.4 16.3108 19.4 12.5ZM12.4995 7.1332C9.53555 7.1332 7.13281 9.53594 7.13281 12.4999C7.13281 15.4638 9.53555 17.8665 12.4995 17.8665C15.4634 17.8665 17.8661 15.4638 17.8661 12.4999C17.8661 9.53594 15.4634 7.1332 12.4995 7.1332ZM16.3339 12.5001C16.3339 10.383 14.6176 8.6668 12.5005 8.6668C10.3834 8.6668 8.66719 10.383 8.66719 12.5001C8.66719 14.6172 10.3834 16.3335 12.5005 16.3335C14.6176 16.3335 16.3339 14.6172 16.3339 12.5001Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgTarget',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>